module.exports = __webpack_public_path__ + "img/headerbanner-grande.6dcbaf3d.jpg";